import { useTranslation } from 'react-i18next'

import { Alert, ButtonWithSpinner, Text } from '@reveni-io/reveni-ui'

import useSeelActivation from './hooks/useSeelActivation'
import SeelConfiguration from './SeelConfiguration/SeelConfiguration'
import { isSeelActivated, isSeelFailed, isSeelInstalling } from './helpers'
import * as Styles from './styles'

const SeelIntegration = ({ integration, storeId, onChange, hasChanges, onRevertChanges, onSave }) => {
  const { t } = useTranslation()
  const { activate, checkInstallStatus, loading, checkingInstallStatus, error, connectionLost, status } =
    useSeelActivation({ integration, storeId })

  const installing = isSeelInstalling(status) && !connectionLost
  const failed = isSeelFailed(status)
  const activated = isSeelActivated(status)

  return (
    <Styles.Container>
      <Text version="v4" type="bodyMRegular">
        {t(
          'Protege los pedidos de tus clientes frente a pérdida, daño y robo durante el transporte. Con la tecnología de Seel, funciona como marca blanca por detrás de Reveni.'
        )}
      </Text>

      <Alert type="info" size="m">
        {t(
          'La tarifa de protección no es reembolsable en devoluciones estándar. Solo se reembolsa si el pedido se cancela antes del envío o si el cliente cancela la protección en un plazo de 24 horas.'
        )}
      </Alert>

      {installing && (
        <Alert type="info" size="m">
          {t('Estamos instalando Package Protection. Puede tardar unos minutos.')}
        </Alert>
      )}

      {failed && !loading && (
        <Alert type="error" size="m">
          {t('No se ha podido completar la instalación. Inténtalo de nuevo.')}
        </Alert>
      )}

      {connectionLost && (
        <>
          <Alert type="warning" size="m">
            {t('Hemos perdido la conexión con la instalación. Pulsa Reintentar para comprobar su estado.')}
          </Alert>

          <Styles.ButtonContainer>
            <ButtonWithSpinner
              onClick={checkInstallStatus}
              loading={checkingInstallStatus}
              disabled={checkingInstallStatus}
              defaultLabel={t('Reintentar')}
              loadingLabel={t('Comprobando…')}
            />
          </Styles.ButtonContainer>
        </>
      )}

      {!activated && !connectionLost && (
        <>
          {error && (
            <Alert type="error" size="m">
              {t(
                'La activación ha fallado. La configuración de tu tienda no es compatible con Package Protection. Revisa los ajustes de tu tienda o contacta con soporte.'
              )}
            </Alert>
          )}

          <Styles.ButtonContainer>
            <ButtonWithSpinner
              onClick={activate}
              loading={loading || installing}
              disabled={loading || installing}
              defaultLabel={failed ? t('Reintentar') : t('Activar')}
              loadingLabel={t('Instalando…')}
            />
          </Styles.ButtonContainer>
        </>
      )}

      {activated && (
        <SeelConfiguration
          integration={integration}
          onChange={onChange}
          hasChanges={hasChanges}
          onRevertChanges={onRevertChanges}
          onSave={onSave}
        />
      )}
    </Styles.Container>
  )
}

export default SeelIntegration
